var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        closeOnClickOutside: _vm.closeOnClickOutside,
        isOpen: _vm.isOpen
      }
    },
    [
      _c("div", { staticClass: "confirm-dialog" }, [
        _c("div", { staticClass: "image-wrapper" }, [
          _c("img", {
            staticClass: "promotion-image",
            attrs: {
              src: require("@static/img/promotion.gif"),
              alt: "ChangedCountry"
            }
          })
        ]),
        _c("div", { staticClass: "title", attrs: { "data-testid": "title" } }, [
          _vm._v("New ePayment Mobile Website 🎉")
        ]),
        _c(
          "div",
          { staticClass: "message", attrs: { "data-testid": "message" } },
          [
            _vm._v(
              " We've released the upgraded ePayment mobile website, ensuring a seamless and improved user experience for all transactions. "
            ),
            _c("span", { staticStyle: { display: "block" } }, [
              _vm._v(" Would you like to give it a try? ")
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "buttons d-flex" },
          [
            _c(
              "EpButton",
              {
                staticClass: "confirm-button",
                attrs: { variant: "outlined", color: "secondary" },
                on: {
                  click: function($event) {
                    return _vm.$emit("discard")
                  }
                }
              },
              [_vm._v("Stay Here")]
            ),
            _c(
              "EpButton",
              {
                staticClass: "discard-button",
                on: {
                  click: function($event) {
                    return _vm.$emit("confirm")
                  }
                }
              },
              [_vm._v(" Continue ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }